import { BsThreeDots } from 'react-icons/bs';
import {  myprojects, projects } from './mock';


export const MyProjects = () => {
    return (
        <div className="my__projects mb-3">
            <h5>Projects</h5>
            <div className="projects">
                <ul>
                {projects && projects?.length > 0 && projects.map((item, i) => {
                        return (
                            <li key={i}>
                                <div>
                                    <p className="projectcard-title">{item.title}</p>
                                    <div className="projectcard-team">
                                     {item.team && item?.team?.length > 0 && item.team.map((person, i) => {
                                          if(i<5){
                                            return <img src={person.user.avatar} key={i} alt={person.title} />
                                          }
                                          return true;
                                    })}
                                    </div>
                                    <div className="projectcard-dots">
                                        <BsThreeDots />
                                    </div>
                                </div>
                            </li>

                        )
                    })}
                    
                    {myprojects.map((item, i) => {
                        return (
                            <li key={i}>
                                <div>
                                    <p className="projectcard-title">{item.title}</p>
                                    <div className="projectcard-team">
                                        {item.img.map((img, i) => {
                                            return <img src={'/assets/images'+img} key={i} alt="" />
                        
                                        })}
                                    </div>
                                    <div className="projectcard-dots">
                                        <BsThreeDots />
                                    </div>
                                </div>
                            </li>

                        )
                    })}

                </ul>
            </div>

            <div><div className="loadmore">Daha fazla</div></div>
        </div>
    )
}